import { useEffect, useState } from 'react';
import { getStatusMessage } from '../common';
import { pathOr } from 'rambda';
import { fold } from 'fp-ts/Either';
import { flow } from 'fp-ts/function';

export const useStatusMessage = () => {
  const [bannerMessage, setBannerMessage] = useState<string>();

  useEffect(() => {
    getStatusMessage().then(
      fold(
        flow(pathOr('', 'message'), setBannerMessage),
        flow(pathOr('', 'description'), setBannerMessage)
      )
    );
  }, []);

  return bannerMessage;
};
